/**
 * @generated SignedSource<<d6c2829e0531dc7c24525b1207b0e496>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TVTodoTeamsPopoverSetTeamMutation$variables = {
  allTeams: boolean;
  employeeId?: string | null;
  id: string;
  teamIds: ReadonlyArray<string>;
};
export type TVTodoTeamsPopoverSetTeamMutation$data = {
  readonly todo: {
    readonly updateTeams: {
      readonly allTeams: boolean;
      readonly assignedRoles: ReadonlyArray<{
        readonly id: string;
        readonly role: {
          readonly id: string;
        };
      }>;
      readonly id: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  } | null;
};
export type TVTodoTeamsPopoverSetTeamMutation$rawResponse = {
  readonly todo: {
    readonly updateTeams: {
      readonly allTeams: boolean;
      readonly assignedRoles: ReadonlyArray<{
        readonly id: string;
        readonly role: {
          readonly id: string;
        };
      }>;
      readonly id: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  } | null;
};
export type TVTodoTeamsPopoverSetTeamMutation = {
  rawResponse: TVTodoTeamsPopoverSetTeamMutation$rawResponse;
  response: TVTodoTeamsPopoverSetTeamMutation$data;
  variables: TVTodoTeamsPopoverSetTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allTeams"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "employeeId",
        "variableName": "employeeId"
      },
      {
        "kind": "Variable",
        "name": "todoId",
        "variableName": "id"
      }
    ],
    "concreteType": "TodoMutation",
    "kind": "LinkedField",
    "name": "todo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "newTeamIds",
            "variableName": "teamIds"
          },
          {
            "kind": "Variable",
            "name": "setAllTeams",
            "variableName": "allTeams"
          }
        ],
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "updateTeams",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allTeams",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "teams",
            "plural": true,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssignedRole",
            "kind": "LinkedField",
            "name": "assignedRoles",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EmployeeRole",
                "kind": "LinkedField",
                "name": "role",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TVTodoTeamsPopoverSetTeamMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TVTodoTeamsPopoverSetTeamMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "c8eed168fd7a6409fc6bc5afe60f5f19",
    "id": null,
    "metadata": {},
    "name": "TVTodoTeamsPopoverSetTeamMutation",
    "operationKind": "mutation",
    "text": "mutation TVTodoTeamsPopoverSetTeamMutation(\n  $id: ID!\n  $teamIds: [ID!]!\n  $allTeams: Boolean!\n  $employeeId: ID\n) {\n  todo(todoId: $id, employeeId: $employeeId) {\n    updateTeams(newTeamIds: $teamIds, setAllTeams: $allTeams) {\n      id\n      allTeams\n      teams {\n        id\n      }\n      assignedRoles {\n        id\n        role {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "00ffa3672a60e9628ab57e05ed4f5f8f";

export default node;
